import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '@/store/auth';

export default function AuthGuard() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const portalStatus = useAuthStore((s) => s.user?.customer?.portal_status);

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (portalStatus === 'pending_approval') {
    return <Navigate to="/pending" replace />;
  }

  return <Outlet />;
}
